import React, {Component} from 'react';
import {GlobalContext} from './context/GlobalContext';
import {getCookie, setCookie} from '../../utils';
import classNames from 'classnames';

class Instructions extends Component {
    constructor(props) {
        super(props);

        const firstTimeVisiting = this.checkIfFirstTimeVisiting();

        this.state = {
            isOpen: firstTimeVisiting,
            containerHeight: 0,
            noTransitions: firstTimeVisiting,
            infoBtnSize: {
                width: 0,
                height: 0
            },
            windowPosition: {
                x: 0,
                y: 0
            }
        };

        this.infoBtnRef = React.createRef();

        this.closeInfoOnScroll = this.closeInfoOnScroll.bind(this);
        this.toggleInfo = this.toggleInfo.bind(this);
        this.calculateContainerHeight = this.calculateContainerHeight.bind(this);
        this.calculateContainerHeightOnResize = this.calculateContainerHeightOnResize.bind(this);
        this.addScrollListener = this.addScrollListener.bind(this);
        this.removeScrollListener = this.removeScrollListener.bind(this);
    }

    componentDidMount() {

        this.setState({
            infoBtnSize: {
                width: this.infoBtnRef.current.offsetWidth,
                height: this.infoBtnRef.current.offsetHeight
            }
        });

        this.calculateContainerHeight();

        window.addEventListener('resize', this.calculateContainerHeightOnResize, false);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.calculateContainerHeightOnResize, false);
    }

    checkIfFirstTimeVisiting() {
        let firstTimeVisiting;

        if (!getCookie('instructionsSeen')) {
            firstTimeVisiting = true;
            setCookie('instructionsSeen', 'true', 30, '/product-catalogue/');
        } else {
            firstTimeVisiting = false;
        }

        return firstTimeVisiting;
    }

    addScrollListener() {
        this.setState({
            windowPosition: {
                x: window.screenX,
                y: window.scrollY
            }
        });

        window.addEventListener('scroll', this.closeInfoOnScroll, false);
    }

    removeScrollListener() {
        window.removeEventListener('scroll', this.closeInfoOnScroll, false);
    }

    closeInfoOnScroll() {
        const {windowPosition, isOpen} = this.state;

        window.scrollTo(windowPosition.x, windowPosition.y); // To prevent scrolling, preventDefault doesn't work

        if (isOpen) {
            this.setState({isOpen: false});
        }
    }

    toggleInfo(e) {
        e.preventDefault();

        this.setState(prevState => ({
            noTransitions: false,
            isOpen: !prevState.isOpen
        }), this.calculateContainerHeight);
    }

    calculateContainerHeightOnResize() {
        this.setState({noTransitions: true});
        this.calculateContainerHeight();
    }

    calculateContainerHeight() {
        if (this.state.isOpen) {
            const
                mainContainer = document.getElementById('shipsViewerRoot'),
                containerHeight = mainContainer.offsetHeight;
            this.setState({containerHeight: containerHeight})
        }
    }

    render() {
        const instructionClasses = classNames(
            'instructions',
            {'instructions--open': this.state.isOpen}
        );

        let instructionStyles = {};

        if (this.state.noTransitions) {
            instructionStyles.transition = 'none';
        }

        if (this.state.isOpen) {
            instructionStyles.height = this.state.containerHeight;
        } else {
            instructionStyles.height = this.state.infoBtnSize.height;
            instructionStyles.width = this.state.infoBtnSize.width;
        }

        if (this.props.isCategoriesListVisible) {
            instructionStyles.visibility = 'hidden';
        }

        return (
            <div
                className={instructionClasses}
                onMouseDown={this.toggleInfo}
                onMouseEnter={this.addScrollListener}
                onMouseLeave={this.removeScrollListener}
                style={instructionStyles}
            >
                <div className="instructions__overlay"/>
                <button
                    className="instructions__info-btn"
                    onClick={e => e.preventDefault()}
                    ref={this.infoBtnRef}
                >
                    View instructions
                </button>
                <div className="instructions__close-btn-container">
                    <button className="instructions__close-btn"
                            onClick={e => e.preventDefault()}
                    >
                        Close and Explore
                    </button>
                    <p className="instructions__small-text">Or click anywhere and start exploring</p>
                </div>
            </div>
        );
    }
}

function InstructionsWithContext(props) {
    return (
        <GlobalContext.Consumer>
            {(context) => (
                <Instructions
                    isCategoriesListVisible={context.isCategoriesListVisible}
                    {...props}
                />
            )}
        </GlobalContext.Consumer>
    )
}

export default InstructionsWithContext;